export function matchesSubstringSearch(item: Record<string, unknown>, query: string, searchFields: string[]): boolean {
  const normalizedQuery = query.trim().toLowerCase().replace(/\s+/g, ' ');
  if (!normalizedQuery) return true;

  return searchFields.some((field) => {
    const value = String(item[field] ?? '')
      .toLowerCase()
      .replace(/\s+/g, ' ');
    return value.includes(normalizedQuery);
  });
}
